








import { defineComponent } from '@vue/composition-api';
import AppIcon from '@berlin-front/common/components/elements/AppIcon';
import { NP_COLOR_MAP } from '@berlin-front/common/variables';

/**
 * 画面上部の閉じるボタン。
 */
export default defineComponent({
  name: 'AppClose',
  components: {
    AppIcon,
  },

  emits: [
    /**
     * closeボタンクリック時に発火するイベント。
     */
    'click',
  ],

  setup() {
    return {
      NP_COLOR_MAP,
    };
  },
});
